export const SHM_TEMP_SLOTS = ['tempNtc1', 'tempNtc2', 'tempPcb'] as const;
export type ShmTempSlot = (typeof SHM_TEMP_SLOTS)[number];

export interface ShmTempLabels { ntc1?: string; ntc2?: string }

export function shmTemperatureTitle(
  slot: ShmTempSlot,
  labels: ShmTempLabels | undefined,
  t: (key: string) => string,
): string {
  if (slot === 'tempNtc1') return labels?.ntc1?.trim() || t('measurement.shm.tempDefaults.ntc1');
  if (slot === 'tempNtc2') return labels?.ntc2?.trim() || t('measurement.shm.tempDefaults.ntc2');
  return t('measurement.shm.tempDefaults.pcb');
}

export interface ChannelSeriesInput {
  channelKey: string;
  time?: any[];
  [k: string]: any;
}

export interface MergedTempSeries {
  time: Date[];
  values: number[];
  /** Source channel of each merged point. */
  channelKeys: string[];
  /** Index of each merged point within its source channel's arrays. */
  srcIndex: number[];
}

/**
 * Temperature probes are read on every channel capture and stored per channel with that
 * channel's `time`. This concatenates one probe (`slot`) across the given channels into a
 * single time-ordered series, skipping null/NaN readings and invalid timestamps.
 */
export function mergeChannelTemps(channels: ChannelSeriesInput[], slot: string): MergedTempSeries | null {
  const pts: { t: number; v: number; ch: string; i: number }[] = [];
  for (const c of channels) {
    const times: any[] = c.time ?? [];
    const values: any[] = c[slot] ?? [];
    for (let i = 0; i < values.length; i++) {
      const v = values[i];
      if (v == null || !Number.isFinite(v)) continue;
      const ms = new Date(times[i]).getTime();
      if (!Number.isFinite(ms)) continue;
      pts.push({ t: ms, v, ch: c.channelKey, i });
    }
  }
  if (!pts.length) return null;
  pts.sort((a, b) => a.t - b.t);
  return {
    time: pts.map((p) => new Date(p.t)),
    values: pts.map((p) => p.v),
    channelKeys: pts.map((p) => p.ch),
    srcIndex: pts.map((p) => p.i),
  };
}
